/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF API v2.0
 * TAF API with OpenAPI, Swashbuckle, and API versioning.
 * OpenAPI spec version: 2.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  IGroupedEmploymentInfo,
  IMembership,
  IOrganisationUnit,
  IPerson,
  UpdatePersonRequest
} from '../../models'
import { customInstance } from '../../../../utils/mutator/custom-instance';
import type { ErrorType, BodyType } from '../../../../utils/mutator/custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getApiV2Member = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IPerson>(
      {url: `/proxy/api/v2/member`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2MemberQueryKey = () => {
    return [`/proxy/api/v2/member`] as const;
    }

    
export const getGetApiV2MemberQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2Member>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2Member>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2MemberQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2Member>>> = ({ signal }) => getApiV2Member(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2Member>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2MemberQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2Member>>>
export type GetApiV2MemberQueryError = ErrorType<unknown>



export function useGetApiV2Member<TData = Awaited<ReturnType<typeof getApiV2Member>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2Member>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2MemberQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2MemberSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2Member>>, TError = ErrorType<unknown>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2Member>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2MemberQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2Member>>> = ({ signal }) => getApiV2Member(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2Member>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2MemberSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2Member>>>
export type GetApiV2MemberSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2MemberSuspense<TData = Awaited<ReturnType<typeof getApiV2Member>>, TError = ErrorType<unknown>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2Member>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2MemberSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const putApiV2Member = (
    updatePersonRequest: BodyType<UpdatePersonRequest>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/proxy/api/v2/member`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePersonRequest
    },
      options);
    }
  


export const getPutApiV2MemberMutationOptions = <TData = Awaited<ReturnType<typeof putApiV2Member>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<UpdatePersonRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['putApiV2Member'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV2Member>>, {data: BodyType<UpdatePersonRequest>}> = (props) => {
          const {data} = props ?? {};

          return  putApiV2Member(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{data: BodyType<UpdatePersonRequest>}, TContext>}

    export type PutApiV2MemberMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV2Member>>>
    export type PutApiV2MemberMutationBody = BodyType<UpdatePersonRequest>
    export type PutApiV2MemberMutationError = ErrorType<unknown>

    export const usePutApiV2Member = <TData = Awaited<ReturnType<typeof putApiV2Member>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{data: BodyType<UpdatePersonRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {data: BodyType<UpdatePersonRequest>},
        TContext
      > => {

      const mutationOptions = getPutApiV2MemberMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiV2MemberUnion = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IOrganisationUnit>(
      {url: `/proxy/api/v2/member/union`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2MemberUnionQueryKey = () => {
    return [`/proxy/api/v2/member/union`] as const;
    }

    
export const getGetApiV2MemberUnionQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2MemberUnionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2MemberUnion>>> = ({ signal }) => getApiV2MemberUnion(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2MemberUnionQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2MemberUnion>>>
export type GetApiV2MemberUnionQueryError = ErrorType<unknown>



export function useGetApiV2MemberUnion<TData = Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2MemberUnionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2MemberUnionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError = ErrorType<unknown>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2MemberUnionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2MemberUnion>>> = ({ signal }) => getApiV2MemberUnion(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2MemberUnionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2MemberUnion>>>
export type GetApiV2MemberUnionSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2MemberUnionSuspense<TData = Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError = ErrorType<unknown>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberUnion>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2MemberUnionSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV2MemberMembership = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IMembership>(
      {url: `/proxy/api/v2/member/membership`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2MemberMembershipQueryKey = () => {
    return [`/proxy/api/v2/member/membership`] as const;
    }

    
export const getGetApiV2MemberMembershipQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2MemberMembershipQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2MemberMembership>>> = ({ signal }) => getApiV2MemberMembership(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2MemberMembershipQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2MemberMembership>>>
export type GetApiV2MemberMembershipQueryError = ErrorType<unknown>



export function useGetApiV2MemberMembership<TData = Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2MemberMembershipQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2MemberMembershipSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError = ErrorType<unknown>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2MemberMembershipQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2MemberMembership>>> = ({ signal }) => getApiV2MemberMembership(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2MemberMembershipSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2MemberMembership>>>
export type GetApiV2MemberMembershipSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2MemberMembershipSuspense<TData = Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError = ErrorType<unknown>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberMembership>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2MemberMembershipSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV2MemberEmployments = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IGroupedEmploymentInfo>(
      {url: `/proxy/api/v2/member/employments`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2MemberEmploymentsQueryKey = () => {
    return [`/proxy/api/v2/member/employments`] as const;
    }

    
export const getGetApiV2MemberEmploymentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2MemberEmploymentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2MemberEmployments>>> = ({ signal }) => getApiV2MemberEmployments(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2MemberEmploymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2MemberEmployments>>>
export type GetApiV2MemberEmploymentsQueryError = ErrorType<unknown>



export function useGetApiV2MemberEmployments<TData = Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2MemberEmploymentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2MemberEmploymentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError = ErrorType<unknown>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2MemberEmploymentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2MemberEmployments>>> = ({ signal }) => getApiV2MemberEmployments(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2MemberEmploymentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2MemberEmployments>>>
export type GetApiV2MemberEmploymentsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2MemberEmploymentsSuspense<TData = Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2MemberEmployments>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2MemberEmploymentsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiV2MemberKillSession = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/proxy/api/v2/member/kill-session`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiV2MemberKillSessionMutationOptions = <TData = Awaited<ReturnType<typeof postApiV2MemberKillSession>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV2MemberKillSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV2MemberKillSession>>, void> = () => {
          

          return  postApiV2MemberKillSession(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,void, TContext>}

    export type PostApiV2MemberKillSessionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV2MemberKillSession>>>
    
    export type PostApiV2MemberKillSessionMutationError = ErrorType<unknown>

    export const usePostApiV2MemberKillSession = <TData = Awaited<ReturnType<typeof postApiV2MemberKillSession>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiV2MemberKillSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    